// @flow
import environment from '../../../environment';
import {postCreator} from '../../../http';

import type {ColorSetting} from '../../../entities';

export const ALLOWED_PRIMARY_COLORS = [
  {
    hex: '#FFFFFF',
    name: 'Blanco',
  },
  {
    hex: '#3A3A49',
    name: 'Negro',
  },
];
export const ALLOWED_SECONDARY_COLORS = [
  {
    hex: '#3A3A49',
    name: 'Negro',
  },
  {
    hex: '#FFFFFF',
    name: 'Blanco',
  },
];

export const DEFAULT_COLOR_OPTIONS = [
  {
    primaryBackgroundColor: '#A39372',
    secondaryBackgroundColor: '#F0EDE5',
  },
  {
    primaryBackgroundColor: '#C27A8B',
    secondaryBackgroundColor: '#EDE6E8',
  },
  {
    primaryBackgroundColor: '#353540',
    secondaryBackgroundColor: '#F2F2F2',
  },
  {
    primaryBackgroundColor: '#4681F4',
    secondaryBackgroundColor: '#F0F3F5',
  },
  {
    primaryBackgroundColor: '#95B998',
    secondaryBackgroundColor: '#F4F4F6',
  },
  {
    primaryBackgroundColor: '#80669D',
    secondaryBackgroundColor: '#E5E0EC',
  },
];

type FontSetting = {
  primaryFontTypeId?: string,
  secondaryFontTypeId?: string,
  enabled?: boolean,
};

type ImageSetting = {
  productImageShapeType?: 'SQUARE' | 'RECTANGLE',
  enabled?: boolean,
};

type StorefrontTemplateSetting = {
  storefrontTemplateType?:
    | 'TEMPLATE_1'
    | 'TEMPLATE_2'
    | 'TEMPLATE_3'
    | 'TEMPLATE_4',
  enabled?: boolean,
};

type UpdateProfileInformationSchema = {
  description?: string,
  videoUrl?: string,
  profilePhotoId?: string,
  videoSocialMediaTypeId?: string,
};

export type SaveInformationRequest = {
  profileInformation?: UpdateProfileInformationSchema,
  colorSetting?: ColorSetting,
  fontSetting?: FontSetting,
  imageSetting?: ImageSetting,
  storefrontTemplateSetting?: StorefrontTemplateSetting,
  description?: string,
  enabledDescription?: boolean,
  featuredComment?: string,
  logoId?: string,
  logoShapeType?: 'SQUARE' | 'RECTANGLE' | 'CIRCLE',
  coverId?: string,
  enabledCover?: boolean,
  faviconId?: string,
  backgroundType?: 'COLOR' | 'PATTERN' | 'PHOTO',
  backgroundPatternId?: string,
  backgroundPhotoMobileId?: string,
  backgroundPhotoDesktopId?: string,
  backgroundEnabled?: boolean,
  backgroundColor?: string,
  storeContactInformationEnabled?: boolean,

  storeNavButtonEnabled?: boolean,
  storeNavButtonText?: string,
  storeNavButtonUrl?: string,
};

export const endpoints = Object.freeze({
  GET_STORE_INFORMATION: `${environment.baseApiUrl}/ui/admin/store/information`,
});

export const saveStoreInformationApi = postCreator(
  endpoints.GET_STORE_INFORMATION
);
